import angular from 'angular';

/**
 * This directive toggles the visibilty based on the current user's id.
 * A check will be performed if the user is part of the supplied array of id's or an admin.
 * If not, the directive will delete the accosiated DOM element.
 */
export default angular.module('services.userVisibility', [])
  .directive('userVisibility', () => {
    'ngInject';

    return {
      controller: 'userVisibilityController',
      restrict: 'A',
      link(scope, _, attrs) {
        scope.idToCheck = parseInt(attrs.userVisibility, 10);
        scope.initController();
      },
    };
  })
  .controller('userVisibilityController', ($scope, $rootScope, $element, usersService) => {
    'ngInject';

    /**
     * Check if the current user is allowed to use a API.
     * The API is defined by the directive's `hasPermission` attribute.
     *
     * @returns {boolean}
     */
    const userIsPermitted = () => {
      if ($rootScope.globals.currentUser === undefined) return null;
      if ($rootScope.permissions.admin) return true;
      return usersService.currentUserId() === $scope.idToCheck;
    };

    /**
     * Toggle the visibility of the directive.
     *
     * @param {boolean} visibility
     */
    const toggleVisibility = (visibility) => {
      if (!visibility) $element.remove();
    };

    /**
     * After the permissions are received by the server, validate the directive's visiblity.
     */
    $rootScope.$on('updatePermissionDirectives', () => {
      toggleVisibility(userIsPermitted());
    });

    /**
     * Also check validate when directive is initialized,
     * because the update might have already been broadcasted.
     */
    $scope.initController = () => {
      toggleVisibility(userIsPermitted());
    };
  })
  .name;
